import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const DurchfuehrungAbschlussKreativ: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Durchführung des Vorhabens" description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default DurchfuehrungAbschlussKreativ;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Kreativwirtschaft.schema.attributes.Abschlussbericht_Kreativ_0012375255_nueber_Der_Planung_Im_Antrag,
				P.Abschlussbericht_Kreativwirtschaft.schema.attributes.Abschlussbericht_Kreativ_0135559957_geschluesselt_Praesenzonline,
				P.Abschlussbericht_Kreativwirtschaft.schema.attributes.Abschlussbericht_Kreativ_0261955374_Angebote_Unterstuetzt_Haben,
				P.Abschlussbericht_Kreativwirtschaft.schema.attributes.Abschlussbericht_Kreativ_0227369028_Reichweiteregionalhessenweit,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucDurchfuehrungAbschlussKreativ = () => {
	return concat(formStruc());
};
